import { useState, useEffect, useCallback, useMemo } from 'react'
import { db } from '../lib/supabase'

export function useExpenses(options = null) {
  const [expenses, setExpenses] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const optionsKey = JSON.stringify(options || {})
  const normalizedOptions = useMemo(() => options || {}, [optionsKey])

  const fetchExpenses = useCallback(async () => {
    setLoading(true)
    const { data, error } = await db.getExpenses(normalizedOptions)
    if (error) {
      setError(error)
    } else {
      setExpenses(data)
    }
    setLoading(false)
  }, [normalizedOptions])

  useEffect(() => {
    fetchExpenses()
  }, [fetchExpenses])

  const createExpense = async (expense) => {
    const { data, error } = await db.createExpense(expense)
    if (!error && data) {
      setExpenses(prev => [data, ...prev])
    }
    return { data, error }
  }

  return {
    expenses,
    loading,
    error,
    refetch: fetchExpenses,
    createExpense,
  }
}

export default useExpenses
